import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { NcsLibModule } from '@ncs/ncs-lib';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material-module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { LoginComponent } from './login/login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { RegistrationComponent } from './registration/registration.component';
import { FormInputErrorComponent } from './form-input-error/form-input-error.component';
import { RouterModule, Routes, Router } from '@angular/router';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { HttpInterceptorService } from './interceptors/http.service';
import { InvitationMemberComponent } from './invitation-member/invitation-member.component';
import { SignupInvitationComponent } from './signup-invitation/signup-invitation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UiformEditComponent } from './components/uiform/uiform-edit/uiform-edit.component';
import { UiformListComponent } from './components/uiform/uiform-list/uiform-list.component';
import { MenuComponent } from './components/menu/menu.component';
import { SideMenuComponent } from './components/uiform/side-menu/side-menu.component';
import { UiformGraphComponent } from './components/uiform/uiform-graph/uiform-graph.component';
import { NcsChartComponent } from './components/ncs-chart/ncs-chart.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ThemeCustomizerComponent } from './theme-customizer/theme-customizer.component';
import { NcsAlertComponent } from './ncs-alert/ncs-alert.component';
import { DynamicChartComponent } from './components/dynamic-chart/dynamic-chart.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { CustomChartComponent } from './custom-chart/custom-chart.component';
import { NcsChartTableComponent } from './components/ncs-chart-table/ncs-chart-table.component';
import { TruncatePipe } from './truncate.pipe';
import { UsecaseHelpComponent } from './usecase-help/usecase-help.component';
import { UiformViewComponent } from './components/uiform/uiform-view/uiform-view.component';
import { NcsTooltipDirective } from './components/ncs-tooltip/ncs-tooltip.directive';
import { DashboardChartsComponent } from './dashboard-charts/dashboard-charts.component';
import { NcsGraphComponent } from './components/ncs-graph/ncs-graph.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UiformPivotComponent } from './components/uiform/uiform-pivot/uiform-pivot.component';
import { TasksListComponent } from './tasks-list/tasks-list.component';
import { UsecaseBaseComponent } from './usecase/usecase-base/usecase-base.component';
import { UiformBaseComponent } from './components/uiform/uiform-base/uiform-base.component';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { SignupComponent } from './common/signup/signup.component';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DatePipe } from '@angular/common';
import { ChildFormDataListComponent } from './child-form-data-list/child-form-data-list.component';
import { ComboboxComponent } from './combobox/combobox.component';
import { NgxEditorModule } from 'ngx-editor';
import { DahodDashboardComponent } from './components/dahod-dashboard/dahod-dashboard.component';
import { FakeLocaleInterceptor } from './interceptors/fake-locale.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { QRCodeModule } from 'angularx-qrcode';
import { AiReportComponent } from './components/uiform/ai-report/ai-report.component';
import { ApplicationDashboardComponent } from './application-dashboard/application-dashboard.component';
import { AddAppRoleAccessComponent } from './add-app-role-access/add-app-role-access.component';
import { AssetReportComponent } from './asset-report/asset-report.component';
import { AppRoleComponent } from './app-role/app-role.component';
import { ApplicationUsersComponent } from './application-users/application-users.component';
import { TableRowEditorComponent } from './table-row-editor/table-row-editor.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { ViewReportComponent } from './view-report/view-report.component';
import { UploadLogsComponent } from './upload-logs/upload-logs.component';
import { ChatComponent } from './chat/chat.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
const routes: Routes = [
];
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    FormInputErrorComponent,
    SidebarComponent,
    InvitationMemberComponent,
    SignupInvitationComponent,
    DashboardComponent,
    UiformEditComponent,
    UiformListComponent,
    MenuComponent,
    SideMenuComponent,
    UiformGraphComponent,
    NcsChartComponent,
    TruncatePipe,
    ForgotPasswordComponent,
    ThemeCustomizerComponent,
    NcsAlertComponent,
    DynamicChartComponent,
    MyProfileComponent,
    CustomChartComponent,
    NcsChartTableComponent,
    UsecaseHelpComponent,
    UiformViewComponent,
    NcsTooltipDirective,
    DashboardChartsComponent,
    NcsGraphComponent,
    ImageCropperComponent,
    UiformPivotComponent,
    TasksListComponent,
    UsecaseBaseComponent,
    UiformBaseComponent,
    ReportsListComponent,
    SignupComponent,
    SupportTicketComponent,
    MenuItemComponent,
    ChildFormDataListComponent,
    ComboboxComponent,
    DahodDashboardComponent,
    ApplicationDashboardComponent,
    AddAppRoleAccessComponent, 
    AppRoleComponent,
    ApplicationUsersComponent,
    TableRowEditorComponent,
    MenuListComponent,
    AiReportComponent,
   AssetReportComponent,
    ViewReportComponent,
    UploadLogsComponent,
    ChatComponent,
  ],
  imports: [
    PickerModule,
    NcsLibModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxMatSelectSearchModule,
    MaterialModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    ImageCropperModule,
    NgxEditorModule,
    NgSelectModule,
    NgxBarcode6Module,
     QRCodeModule,
    RouterModule.forRoot(routes),
    NgxDaterangepickerMd.forRoot(),
     TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FakeLocaleInterceptor,
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    //HttpServiceService,
    //ServiceLocatorService,
    //EndpointServiceService,
    //DataValidatorService,
    //EventService,
    // DecimalPipe,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
